//@ts-nocheck
import React, { useEffect, useRef } from "react";
import { animate, useInView } from "framer-motion";

const Stat = ({ num, suffix, decimals = 0, subheading }) => {
  const ref = useRef(null);
  const isInView = useInView(ref);

  useEffect(() => {
    if (!isInView) return;

    animate(0, num, {
      duration: 2.5,
      onUpdate(value) {
        if (!ref.current) return;

        ref.current.textContent = value.toFixed(decimals);
      },
    });
  }, [num, decimals, isInView]);

  return (
    <div className="flex w-72 flex-col items-center py-8 sm:py-0">
      <p className="mb-2 text-center text-7xl font-semibold sm:text-6xl text-black">
        <span ref={ref}></span>
        {suffix}
      </p>
      <p className="max-w-48 text-center text-black">{subheading}</p>
    </div>
  );
};

export const CountUpStats = () => {
  return (
    <div className="mx-auto max-w-3xl px-4  ">
    
      <div className="flex flex-col items-center justify-center sm:flex-row">
        <Stat
          num={34}
          suffix="M+"
          subheading="Small Businesses in the U.S."
        />
        <div className="h-[1px] w-12 bg-indigo-200 sm:h-12 sm:w-[1px]" />
        <Stat
          num={61}
          suffix="M+"
          subheading="Jobs Generated by Small Businesses"
        />
        <div className="h-[1px] w-12 bg-indigo-200 sm:h-12 sm:w-[1px]" />
        <Stat
          num={43}
          suffix="%"
          subheading="of U.S. GDP from Small Businesses"
        />
      </div>
    </div>
  );
};

